/**
 * 내 계정 폼 zod 스키마(specs/053) — 서버 규칙(DisplayNameGenerator·DisplayNameChangeRequest)과 같은 값.
 * 서버가 최종 검증(정규화·제어 문자)하며, 여기서는 즉시 피드백만 준다.
 */
import { z } from 'zod';

export const DISPLAY_NAME_MAX = 30;

export const displayNameSchema = z.object({
  displayName: z
    .string()
    .trim()
    .min(1, '표시 이름을 입력해 주세요.')
    .max(DISPLAY_NAME_MAX, `표시 이름은 ${DISPLAY_NAME_MAX}자 이하여야 합니다.`),
});
export type DisplayNameValues = z.infer<typeof displayNameSchema>;
